import React from "react";
import imageUrl from "utils/imageUrl";
function Market() {
  return (
    //   <!-- ==== market section start ==== -->
    <section className="market market--two section__space__bottom">
      <div className="container">
        <div
          className="market__area market__area--two section__space bg__img"
          data-background={imageUrl("home/light-two.png")}
          style={{ backgroundImage: `url(${imageUrl("home/light-two.png")})` }}
        >
          <div className="row d-flex align-items-center">
            <div className="col-lg-6">
              <div className="content">
                <h5 className="neutral-top">Web 3.0 real estate marketplace</h5>
                <h2>You Invest. Revest Does the Rest</h2>
                <p>
                  Transparent Web3 Real Estate Investing . Join us and
                  experience a smarter,better way to invest in Web3 real estate
                </p>
                <a href="properties.html" className="button button--effect">
                  Buy Now
                </a>
                <img src={imageUrl("home/market-arrow.png")} alt="Go to" />
              </div>
            </div>
          </div>
          <img
            src={imageUrl("home/market-two-illustration.png")}
            alt="Explore the Market"
            className="d-none d-lg-block market__two__thumb"
          />
        </div>
        <div className="market__features">
          <div className="row">
            <div className="col-md-6 col-xl-4">
              <div className="market__features__single shadow__effect__secondary">
                <img src={imageUrl("icons/gain.png")} alt="Gain Instant" />
                <h4>Buy a home</h4>
                <p className="neutral-bottom">
                  Find your place with an immersive photo experience and the
                  most listings you won’t find anywhere else.
                </p>
                <a
                  href="javascript:void(0)"
                  className="button button--secondary button--effect my-4"
                >
                  Browse Homes
                </a>
              </div>
            </div>
            <div className="col-md-6 col-xl-4">
              <div className="market__features__single market__features__single--alt shadow__effect">
                <img src={imageUrl("icons/noticed.png")} alt="Get noticed" />
                <h4>Sell a home</h4>
                <p className="neutral-bottom">
                  No matter what path you take to sell your home, we can help
                  you navigate a successful sale.
                </p>

                <a
                  href="javascript:void(0)"
                  className="button button--secondary button--effect my-4"
                >
                  See Your Options
                </a>
              </div>
            </div>
            <div className="col-md-6 col-xl-4">
              <div className="market__features__single alt shadow__effect__secondary">
                <img src={imageUrl("icons/focus.png")} alt="Focus on Deals" />
                <h4>Rent a home</h4>
                <p className="neutral-bottom">
                  Discover a place that checks all of your boxes. Filter your
                  rental search, and find exactly what you’re looking for.
                </p>
                <a
                  href="javascript:void(0)"
                  className="button button--secondary button--effect my-4"
                >
                  Find Rentals
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    // <!-- ==== #market section end ==== -->
  );
}

export default Market;
